import React, {useState} from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Trans } from 'react-i18next';

export const RentPopupContainer = styled.div`
    display: ${(props) => props.display};
    flex-direction: column;
    width: 536px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    background-color: #262626;
    z-index: 1;
`
export const RentPopupWrapper = styled.div`
    margin:32px;
`

export const RentPopupCaption = styled.div`
    color: white;
    line-height:24px;
    font-size:20px;
    font-weight:bold;
    text-align:left;
`
export const RentPopupContent = styled.div`
    color: #8c8c8c;
    font-size: 16px;
    margin-top: 10px;
    text-align: left;
    line-height: 24px;
`
export const RentPopupButtonWrapper = styled.div`
    display:flex;
    width:100%;
    flex-direction:row;
    margin-top: 20px;
`
export const CancelButton = styled.button`
    font-size: 16px;
    border: 1px white solid;
    color: white;
    background-color: transparent;
    height: 63px;
    border-radius: 10px;
    line-height:19px;
    flex:1;
    margin-right: 5px;
    
`
export const RentButton = styled.button`
    margin-left: 5px;
    flex: 1;
    font-size: 16px;
    line-height:19px;
    border: none;
    border-radius: 10px;
    background-color: #40a9ff;
    color: white;
`
export const TestSpan = styled.span`
    color: #40a9ff;
    
`

const RentPopup = ({display, Cancel}) => {
    const { t } = useTranslation()
    const [numberOfIce, setNumberOfIce] = useState(6000);
    const [serviceFee, setServiceFee] = useState((numberOfIce * 2) / 100);


  return (
    <>
    <RentPopupContainer display={display}>
        <RentPopupWrapper>
            <RentPopupCaption>{t("page5.rentPopup.caption")}</RentPopupCaption>
            <RentPopupContent>
                <Trans i18nKey="page5.rentPopup.text">
                Are you sure you wish to rent this wearable ?
                To rent it, your walet must have at least 
                <TestSpan>{{numberOfIce}}</TestSpan> 
                ICE  for rental along with an additional 
                {{serviceFee}} ICE for service fees (2%).
                </Trans>
            </RentPopupContent>
            <RentPopupButtonWrapper>
                <CancelButton onClick={Cancel}>{t("page5.rentPopup.cancel")}</CancelButton>
                <RentButton>{t("page5.rentPopup.rent")}</RentButton>
            </RentPopupButtonWrapper>
        </RentPopupWrapper>
    </RentPopupContainer>
    </>
  )
}

export default RentPopup